import i18next from 'i18next';
import {
  getDefaultMinAndMaxDate,
  validationSchemaNumeroPieces,
  validationSchemaPrejudiceBase,
} from 'src/constants/prejudice/validation';
import { dateString } from 'src/helpers/yup';
import {
  DFTPRowTypes,
  PrejudiceFormCalendrierDeficitFonctionnelTemporairePartiel,
  PrejudiceType,
} from 'src/types/prejudice.type';
import { Procedure } from 'src/types/procedure.type';
import { Victime } from 'src/types/victime.type';
import * as yup from 'yup';

export const validationSchemaCalendrierDeficitFonctionnelTemporairePartiel = ({
  procedure,
  victime,
  prejudiceType,
}: {
  procedure: Procedure;
  victime: Victime;
  prejudiceType: PrejudiceType;
}): yup.ObjectSchema<PrejudiceFormCalendrierDeficitFonctionnelTemporairePartiel> => {
  const { minDate, maxDate } = getDefaultMinAndMaxDate({
    procedure,
    victime,
    prejudiceType,
  });
  return validationSchemaPrejudiceBase.shape({
    forfaitJour: yup.number().nullable().defined(),
    rows: yup
      .array()
      .defined()
      .of(
        yup.object({
          dateDebut: dateString()
            .nullable()
            .minDate(undefined, minDate.message, minDate.date)
            .maxDate(undefined, maxDate.message, maxDate.date)
            .defined()
            .when(['type'], ([type], schema) =>
              type === 'dftp' ? schema.required() : schema,
            ),
          dateFin: dateString()
            .nullable()
            .minDate(
              'dateDebut',
              i18next.t('validation.prejudices.dates.minDateDebut') || '',
            )
            .maxDate(undefined, maxDate.message, maxDate.date)
            .defined()
            .when(['type'], ([type], schema) =>
              type === 'dftp' ? schema.required() : schema,
            ),
          joursPeriode: yup.number().required(),
          joursHospitalisationADeduire: yup
            .number()
            .optional()
            .when(['type'], ([type], schema) => {
              if (type === 'dftp') {
                return schema.defined();
              } else {
                return schema;
              }
            }),
          deduireJoursHospitalisation: yup
            .boolean()
            .when(['type'], ([type], schema) => {
              if (type === 'dftp') {
                return schema.required();
              } else {
                return schema;
              }
            }),
          totalJours: yup.number().required(),
          percentage: yup
            .number()
            .nullable()
            .min(0)
            .max(100)
            .when(['type'], ([type], schema) => {
              if (type === 'dftp') {
                return schema.required();
              } else {
                return schema;
              }
            }),
          forfaitJour: yup.number().when(['type'], ([type], schema) => {
            if (type === 'dftp') {
              return schema.required();
            } else {
              return schema;
            }
          }),
          montantTotal: yup.number().required().min(0),
          commentaires: yup
            .string()
            .optional()
            .nullable()
            .when(['type'], ([type], schema) => {
              if (type === 'autreComposante') {
                return schema.required();
              } else {
                return schema;
              }
            }),
          numerosPieces: validationSchemaNumeroPieces,
          type: yup.string().defined().oneOf(DFTPRowTypes),
        }),
      ),

    total: yup.number().required(),
  });
};
